
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/sanu",
      function () {
        return require("private-next-pages/cases/sanu/index.tsx");
      }
    ]);
  